function cutGame(appJQ,game_conf){


    game_conf=$.extend({
        imagesMapArr:[],
        imagesPreloader:{},
        spinePreloader:{},
        onLoad:false,
        width:1280,height:780
    },game_conf);

    var thisMain=this;

    var cutObj;
    var lastPoint=[0,0];
    var cutPointsArr=[];

    var settings=$.extend({width:1280,height:780},game_conf);
    var collisionMainObj;
    this.wasRemoved=0;

    this.gameObj;

    function ninjaGame(){
        this.app=new PIXI.Application({
            width: settings.width, height: settings.height,transparent:true,antialias: true,
            view:appJQ[0]
        });
        this.spineResources;
        this.viewContainer=new PIXI.Container();
        this.app.stage.addChild(this.viewContainer);
        this.mainContainer=new PIXI.Container();
        this.app.stage.addChild(this.mainContainer);
        this.frontContainer=new PIXI.Container();
        this.app.stage.addChild(this.frontContainer);
        cutObj.init(this.app);
        this.collisionArr=[];
        this.viewArr=[];
        this.frontArr=[];
        this.cut_point=[];
        this.cut_point_last=[];

        this.isCutStop=0;

        this.speed=100;
        this.gameLogArr=[];
        this.deltaSum=0;
    }
    ninjaGame.prototype={
        gameLoopStart:function(delta){
            //abstract
        },
        gameLoop:function(delta){
            var delta_speed=delta;
            if(this.speed!=100){
                delta_speed=delta*this.speed/100;
            }
            this.gameLoopStart(delta_speed,this.speed);

            cutObj.update(delta);


            this.prepareCutPoints();
            var i,i_max=this.collisionArr.length-1,obj;
            for(i=i_max;i>=0;i--){
                obj=this.collisionArr[i];

                if(!obj.update(delta_speed,this.speed)){
                    obj.remove();
                    this.collisionArr.splice(i,1);
                }
            }
            i_max=this.viewArr.length-1;
            for(i=i_max;i>=0;i--){
                obj=this.viewArr[i];
                if(!obj.update(delta_speed,this.speed)){
                    obj.remove();
                    this.viewArr.splice(i,1);
                }
            }
            i_max=this.frontArr.length-1;
            for(i=i_max;i>=0;i--){
                obj=this.frontArr[i];
                if(!obj.update(delta_speed,this.speed)){
                    obj.remove();
                    this.frontArr.splice(i,1);
                }
            }
            this.deltaSum+=delta_speed;
            if(this.gameLogArr.length){
                _moduleEvents.trigger("cutGameEvent");
            }
            return true;
        },
        start:function(){
            var thc=this;
            this.app.ticker.add(
                function(delta){thc.gameLoop(delta);}
            );

        },
        addViewObj:function(objName,arg_arr){
            var obj=myConstruct(objName,arg_arr);
//            var obj= new myPixiObj.drawCustom(arg_arr);
            this.viewContainer.addChild(obj);
            this.viewArr.push(obj);
            return obj;
        },
        addFrontObj:function(objName,arg_arr){
            var obj=myConstruct(objName,arg_arr);
            this.frontContainer.addChild(obj);
            this.frontArr.push(obj);
            return obj;
        },
        addThrow:function(type,conf){
            var obj=new objCollisionThrow(type,conf);
            this.mainContainer.addChild(obj);
            this.collisionArr.push(obj);
        },
        addStatic:function(type,conf){
            var obj=new objCollisionStatic(type,conf);
            this.mainContainer.addChild(obj);
            this.collisionArr.push(obj);
        },
        addMovePath:function(type,conf){
            var obj=new objCollisionPath(type,conf);
            this.mainContainer.addChild(obj);
            this.collisionArr.push(obj);
        },
        addCollisionCustom:function(type,conf){
            var obj= new objCollisionCustom(type,conf);
            this.mainContainer.addChild(obj);
            this.collisionArr.push(obj);
            return obj;
        },

        prepareCutPoints:function(){
                //_collisionPointObjArr
            if(this.isCutStop){
                cutPointsArr=[];
                return false;
            }
           this.cut_point_last=[this.cut_point[0],this.cut_point[1]];
           this.cut_point=[lastPoint[0],lastPoint[1]];
           if((this.cut_point_last[0]==this.cut_point[0] && this.cut_point_last[1]==this.cut_point[1]) ||
           (this.cut_point_last[0]==this.cut_point_last[1] && this.cut_point_last[0]==0) ||
           (this.cut_point[0]==0 && this.cut_point[1]==0)
            ){
                cutPointsArr=[];
                return false;
           }
           cutPointsArr=[copyArray(this.cut_point_last)];
            var end_p=copyArray(this.cut_point),
            start_p=copyArray(this.cut_point_last);


            var distance2=Math.pow(start_p[0]-end_p[0],2)+Math.pow(start_p[1]-end_p[1],2);
            var step=5;
            if(distance2<=step*step){
                cutPointsArr.push(copyArray(this.cut_point));
                return true;
            }
            var distance=Math.sqrt(distance2),points_count=Math.ceil(distance/step);

            var dir=makeVector(start_p,end_p),i,p;
            for(i=1;i<=points_count;i++){
                p=[Math.round(start_p[0]+dir[0]*i/points_count),Math.round(start_p[1]+dir[1]*i/points_count)]
                cutPointsArr.push(copyArray(p));
            }


            return true;
        },
        addLog:function(log){
            log=$.extend({type:"",cut_data:{
                scale:100,
                pos:[-1000,-1000],
                img_name:"",
                type:"",
                angle:0
            }},log);

            this.gameLogArr.push(log);
        }
    };
    function collisionMain(){
        this.map_storage={};
    };
    collisionMain.prototype={
        privAddMap:function(name,obj){
            var map;
            obj=$.cutImageMapObj(name);
            map=copyArrayDim(obj.data);
            this.map_storage[name]=map;
        },
        takeMap:function(name){
            if(typeof this.map_storage[name]=="undefined"){
                this.privAddMap(name);
            }
            return this.map_storage[name];
        }
    };
    collisionMainObj=new collisionMain();
    function collisionObj(conf){
        conf=$.extend({
            type:"add"
        },conf);

        this.easyMobile=conf.easyMobile;
        this.cutNumber=0;
        this.type=conf.type;
        this.lastCut=0;
        this.point_storage=[];//[0,0,0];=>cut x,y,is in image
    }
    collisionObj.prototype={
        addCut:function(howmany){
            if(!howmany){
                howmany=1;
            }
            this.cutNumber+=howmany;
        },
        takeCutsNumber:function(){
            return this.cutNumber;
        },
        rememberPointRes:function(arr){
            this.point_storage=copyArray(arr);
        },
        takeRememberPointRes:function(){
            return copyArray(this.point_storage);
        },
        clearRememberPointRes:function(){
            this.point_storage=[];
        },

        prepareCollisionInShape:function(animObj,conf){
            //extend cutPointsArr, add column[2], 0-out image,1-in image
            //sprite_frame,img_pos,img_size_org,angle,scale_int
            var img_size_org=conf.img_size;
//            var angle=conf.angle;
//            var sprite_frame=conf.sprite_frame;
            var img_pos=conf.img_pos;
//            var scale_int=conf.scale_int


            var collisionPointArr=copyArrayDim(cutPointsArr),collisionPoint,i;
            var img_size=[];
            var need_check=0;

            img_size[0]=Math.max(img_size_org[0],img_size_org[1]);//don't multiply by scale_float
            img_size[0]=Math.round(img_size[0]*0.71);
            img_size[1]=img_size[0];

            for(i in collisionPointArr){
                collisionPoint=collisionPointArr[i];
                if(img_pos[0]-img_size[0]<collisionPoint[0] && img_pos[0]+img_size[0]>collisionPoint[0] &&
                img_pos[1]-img_size[1]<collisionPoint[1] && img_pos[1]+img_size[1]>collisionPoint[1] ){
                    collisionPoint[2]=1;
                    need_check=1;
                }
                else{
                   collisionPoint[2]=0;
                }
            }
            if(need_check){
                this.isInImageArr(animObj,conf,collisionPointArr);
            }
            return collisionPointArr;
        },
        isInImageArr:function(animObj,conf,collisionPointArr){
//            var data=[ -5,-55 , 22,-42 , 43,5 , 37,34 , 7,52 , -23,47 , -44,19 , -37,-21 , -6,-55];

            var angle_pi=conf.angle_pi;
            var sprite_frame=conf.sprite_frame;
            var img_pos=conf.img_pos;
            var scale_float=1;
            if(conf.scale_int!=100){
                scale_float=conf.scale_int/100;
            }

            var data=animObj.takeMap();
            var i,i_max;
            var p,t;
            if(scale_float!=1){
                for(i in data){
                    data[i]=data[i]*scale_float;
                }
            }
            if(conf.dir==-1){
                i_max=data.length;
                for(i=0;i<i_max;i+=2){
                    data[i]=-data[i];
                }
            }

            if(angle_pi){
                var x,y,cosA=Math.cos(angle_pi),sinA=Math.sin(angle_pi);
                i_max=data.length;
                for(i=0;i<i_max;i+=2){
                    x=data[i];
                    y=data[i+1];
                    data[i]=Math.round(x*cosA-y*sinA);
                    data[i+1]=Math.round(x*sinA+y*cosA);
                }
            }


            var polygonObj= new PIXI.Polygon(data);

            for(i in collisionPointArr){
                p=collisionPointArr[i];
                if(p[2]==1){
                    t=[p[0]-img_pos[0],p[1]-img_pos[1]];
                    if(!polygonObj.contains(t[0],t[1])){
                        p[2]=0;
                    }
                }
            }
        },
        isCut:function(animObj,conf){
            conf=$.extend({
                sprite_frame:0,
                sprite_part:-1,
                img_pos:[0,0],
                img_size:[0,0],
                angle_pi:0,
                scale_int:100,
                dir:1
            },conf);
            if(cutPointsArr.length==0){
                this.clearRememberPointRes();
                return 0;
            }

            var collisionPointArr=this.prepareCollisionInShape(animObj,conf);
            var i,len=collisionPointArr.length;
            var cutNuber=0,inSpapePoints=0;
            if(len){
                var rememberPoint=this.takeRememberPointRes();
                if(rememberPoint.length){
                    len=collisionPointArr.unshift(rememberPoint);
                }

                for(i=0;i<=len-2;i++){
                    if(collisionPointArr[i][2]==1){
                        inSpapePoints++;
                    }
                    if((collisionPointArr[i][2]==1 && collisionPointArr[i+1][2]==0) /*|| inSpapePoints>1*/){
                        cutNuber++;
                        break;

                    }
                }
                this.rememberPointRes(collisionPointArr[(len-1)]);
            }
            if(cutNuber){
                this.addCut();
                return 1;
            }
            return 0;
        },


    };


    var cutGameElement={};
    cutGameElement.img=function(conf){
        myPixiElement.img.call(this,conf);
    };
    cutGameElement.img.prototype = Object.create(myPixiElement.img.prototype);
    cutGameElement.img.prototype=$.extend(cutGameElement.img.prototype,{
        takeMap:function(){
            return copyArrayDim(collisionMainObj.takeMap(this.conf.map_name)[0]);
        }
    });
    cutGameElement.sprite=function(conf){
        myPixiElement.sprite.call(this,conf);
    };
    cutGameElement.sprite.prototype = Object.create(myPixiElement.sprite.prototype);
    cutGameElement.sprite.prototype=$.extend(cutGameElement.sprite.prototype,{
        takeMap:function(){
            return copyArrayDim(collisionMainObj.takeMap(this.conf.map_name)[this.frame_id]);
        }
    });

    cutGameElement.spine=function(conf){
        myPixiElement.spine.call(this,conf);
    };
    cutGameElement.spine.prototype = Object.create(myPixiElement.spine.prototype);
    cutGameElement.spine.prototype=$.extend(cutGameElement.spine.prototype,{
        takeMap:function(){
            var howlong_max=this.state.tracks[0].animationEnd;
            var howlong=Math.max(0,this.state.tracks[0].animationLast);

            var ref=collisionMainObj.takeMap(this.conf.map_name);
            var frame_id=0;
            var frame_max=ref.length-1;
            if(frame_max>0){
                frame_id=Math.round(howlong/howlong_max*frame_max);
            }


            return copyArrayDim(ref[frame_id]);
        }
    });








    function objCollisionStatic(type,conf){
        PIXI.Container.call(this);

        this.type=type;
        this.imgName;



        conf=$.extend({
            img:"egg",
            pos:[0,0],
            angle:0,
            scale:100,
            onCut:false,
            anim_type:"img",
            map_name:"",
            spine_conf:{},
            img_conf:{},
            sprite_conf:{}
        },conf);
        if(conf.map_name==""){
            conf.map_name=conf.img;
        }
        this.conf=conf;


        this.myObj = new cutGameElement[conf.anim_type](conf);

        this.imgName=conf.img;
        this.addChild(this.myObj);

        this.x=conf.pos[0];
        this.y=conf.pos[1];

        var angle_pi=conf.angle/180*Math.PI;
        this.rotation=angle_pi;
        this.scale.set(conf.scale/100);
        this.collisionObj=new collisionObj({eventType:this.type});

    }
    objCollisionStatic.prototype = Object.create(PIXI.Container.prototype);
    objCollisionStatic.prototype= $.extend(objCollisionStatic.prototype,{
        update:function(delta){
            this.myObj.myUpdate(delta);





            if(this.collisionObj.isCut(this.myObj,{
                img_pos:[this.x,this.y],
                img_size:[this.width,this.height],
                angle_pi:this.rotation,
                scale_int:this.conf.scale
            })){
                var logObj={type:"cut_init",cut_data:{
                    type:this.type,img_name:this.imgName,scale:this.conf.scale,angle:this.conf.angle,pos:[this.x,this.y]
                }};
                if(typeof this.conf.onCut=="function"){
                    this.conf.onCut.call(thisMain.gameObj,logObj);
                }
                thisMain.gameObj.addLog(logObj);
                return 0;

            }
            return 1;
        },

        remove:function(){
            this.myObj.myRemove();
            this.destroy();
        }
    });




    function objCollisionPath(type,conf){

        PIXI.Container.call(this);

        conf=$.extend({
            img:"",
            point_start:[],
            point_center:[400,200],
            speed:0.33,
            onCut:false,
            onEnd:false,
            anim_type:"img",
            map_name:"",
            change_dir:0,
            scale_arr:[100,40],
            scale_sm:[],
            cut_from_step:0,
            goal_points:3,
            scale_fun:false,
            spine_conf:{},
            img_conf:{},
            sprite_conf:{}
        },conf);
        this.dir=1;
        this.last_point=[];
        if(conf.map_name==""){
            conf.map_name=conf.img;
        }
        var point_center=conf.point_center;

        this.conf=conf;

        this.scale_sm_len=conf.scale_sm.length;
        if(this.scale_sm_len){
            this.scale_sm=new Smooth(conf.scale_sm);
        }

        this.step=1;
        this.type=type;
        if(conf.img==""){
            if(type=="good"){
                conf.img="girl_good"+mt_rand(1,4);
            }
            else{
                conf.img="girl_bad"+mt_rand(1,4);
            }
        }

        this.myObj = new cutGameElement[conf.anim_type](conf);


        this.imgName=conf.img;
        this.x=-1000;
        this.y=-1000;

        this.collisionObj=new collisionObj({eventType:this.type});

        this.addChild(this.myObj);

        this.animObj=[];
        this.pointNumber=0;
        var border_work=[170,980];
        border_work[2]=border_work[1]-border_work[0];
        var ctx_size=[settings.width, settings.height];
        var prop=Math.round((point_center[0]-border_work[0])/border_work[2]*100);
        if(prop<10){
            prop=0;
        }
        if(prop>90){
            prop=100;
        }
        var points=[],last_point,i,i_max=conf.goal_points,dis,x;


        function findPoint(last_point){
            var vec=makeVector(last_point,point_center,dis);
            var alfa=angleClockFromVector(vec);
            var beta=alfa+mt_rand(-60,60);
            beta-=90;
            var beta_r=beta/180*Math.PI;
            var v=[
                dis*Math.cos(beta_r),
                dis*Math.sin(beta_r)
            ];
            var next_point=addVector(last_point,v);
            next_point[0]=Math.max(next_point[0],border_work[0]);
            next_point[0]=Math.min(next_point[0],border_work[1]);
            next_point[1]=Math.max(20,next_point[1]);
            next_point[1]=Math.min(next_point[1],ctx_size[1]-80);
            return next_point;
        }

        dis=Math.round(border_work[2]*70/100);
        if(conf.point_start.length==0){
            if(mt_rand(1,100)>prop){
                //1
                points.push([ctx_size[0],mt_rand(0,ctx_size[1])]);
                last_point=[border_work[1],mt_rand(0,ctx_size[1])];
                points.push(last_point);
            }
            else{
                //0
                points.push([0,mt_rand(0,ctx_size[1])]);
                last_point=[border_work[0],mt_rand(0,ctx_size[1])];
                points.push(last_point);
            }
        }
        else{
            last_point=conf.point_start;
            points.push(last_point);
        }
        for(i=0;i<i_max;i++){
            last_point=findPoint(last_point);
            points.push(last_point);
        }
        points.push(point_center);
        this.animObj=new Smooth(points);
        this.pointNumber=points.length;
        this.step_max=120;
    }
    objCollisionPath.prototype = Object.create(PIXI.Container.prototype);
    objCollisionPath.prototype= $.extend(objCollisionPath.prototype,{
        update:function(delta,speed){
            this.myObj.myUpdate(delta);
            this.step=this.step+delta*this.conf.speed;
            var div=this.step/this.step_max;

            var scale;
            if(this.scale_sm_len){
                scale=this.scale_sm(div*(this.scale_sm_len-1));
            }
            else{
                var size=this.conf.scale_arr;
                scale=size[0]-(size[0]-size[1])*div;
            }




            var pp=this.animObj(div*(this.pointNumber-1));
            var x=Math.round(pp[0]);
            var y=Math.round(pp[1]);
            if(this.conf.change_dir!=0 && this.last_point.length){
                if(this.last_point[0]>x){
                    this.dir=-1*this.conf.change_dir;
                }
                else{
                    this.dir=1*this.conf.change_dir;
                }
            }
            this.last_point=[x,y];
            var angle=0;
            var angle_pi=0;
            this.scale.set(this.dir*scale/100,scale/100);


            if(this.step>=this.conf.cut_from_step*speed/100 &&   this.collisionObj.isCut(this.myObj,{
                img_pos:[x,y],
                img_size:[this.width,this.height],
                angle_pi:angle_pi,
                scale_int:scale,
                dir:this.dir
            })){
                var logObj={type:"cut",cut_data:{
                    type:this.type,img_name:this.imgName,scale:scale,angle:angle,pos:[x,y],
                    dir:this.dir
                }};
                if(typeof this.conf.onCut=="function"){

                    this.conf.onCut.call(thisMain.gameObj,logObj);
                }
                thisMain.gameObj.addLog(logObj);
                return 0;
            }
            this.x=x;
            this.y=y;




            if(this.step>=this.step_max){
                var logObj={type:"end",cut_data:{
                    type:this.type,img_name:this.imgName,scale:scale,angle:angle,pos:[x,y]
                }};
                if(typeof this.conf.onEnd=="function"){
                    this.conf.onEnd.call(thisMain.gameObj,logObj);
                }
                thisMain.gameObj.addLog(logObj);

                return 0;

            }
            return 1;
        },
        remove:function(){
            this.myObj.myRemove();
            this.destroy();
        }
    });











    function objCollisionThrow(type,conf_all){
        PIXI.Container.call(this);

        this.step=1;
        this.step_max;
        this.type=type;
        this.type_val=0;
        this.imgName;
        this.v0;
        this.angle;
        this.g;
        this.x=-100;
        this.y=-100;

        this.rotation_step=0;
        this.rotation_state=0;
        conf_all=$.extend({
            img:"egg",g:0.4,h_max:1000,w_margin:50,boss_x:-1,
            anim_type:"img",
            dir:1,
            map_name:"",
            onCut:false,
            onEnd:false,
            rotation_step_arr:[0,0],//egg 3-12
            step_part:1,
            scale_arr:[100,100],
            spine_conf:{},
            img_conf:{},
            sprite_conf:{},
            boss_die_count:5
        },conf_all);
        if(conf_all.map_name==""){
            conf_all.map_name=conf_all.img;
        }

        this.conf=conf_all;

        this.scale_arr=copyArray(conf_all.scale_arr);
        this.scale_int=conf_all.scale_arr[0];

        this.myObj = new cutGameElement[conf_all.anim_type](conf_all);


        this.imgName=conf_all.img;
        this.addChild(this.myObj);

//         this.pivot.set(this.img.width/2,this.img.height/2);

        if(conf_all.rotation_step_arr[0]!=0 || conf_all.rotation_step_arr[1]!=0){
            this.rotation_step=mt_rand(conf_all.rotation_step_arr[0],conf_all.rotation_step_arr[1]);
        }




        this.collisionObj=new collisionObj({eventType:this.type});


        this.g=conf_all.g;//1.1 trudność ustawia grawitacja!!!

        var v_range=[0,1000];
        var was_error=0;
        function takeVfromH(h,g,alfa){
            var val=Math.sqrt(h*2*g/Math.pow(Math.sin(alfa),2));
            return val;
        }
        function takeVfromR(r,g,alfa){
            var val=Math.sqrt(r*g/Math.sin(2*alfa));
            return val;
        }
        function takeVfromT(t,g,alfa){
           var val=(t*g/2/Math.sin(alfa));
           return val;
        }
        function updateV(v_min,v_max,tt){
            v_range[0]=Math.max(v_range[0],v_min);
            v_range[1]=Math.min(v_range[1],v_max);
            v_range[0]=Math.round(v_range[0]);
            v_range[1]=Math.round(v_range[1]);
            if(v_range[0]>v_range[1]){
                was_error=1;
            }
        }
        var angle=mt_rand(70,89);
        this.angle=angle/180*Math.PI;

        var w_border=[conf_all.w_margin ,settings.width-conf_all.w_margin],w_border_len=w_border[1]-w_border[0];
        var h_range=[Math.round(settings.height*0.7),conf_all.h_max];
        var r_range=[10,w_border_len];
        var t_range=[20,300];
        updateV(
            takeVfromH(h_range[0],this.g,this.angle),
            takeVfromH(h_range[1],this.g,this.angle),
            1
        );
        updateV(
            takeVfromR(r_range[0],this.g,this.angle),
            takeVfromR(r_range[1],this.g,this.angle),
            2
        );
        updateV(
            takeVfromT(t_range[0],this.g,this.angle),
            takeVfromT(t_range[1],this.g,this.angle),
            3
        );

        this.v0=mt_rand(v_range[0],v_range[1]);
        this.step_max=Math.ceil(2*this.v0*Math.sin(this.angle)/this.g);
        var range=Math.round(this.v0*this.v0*Math.sin(this.angle*2)/this.g);
        this.start=[w_border[0]+mt_rand(0,w_border_len-range),0];



        if(mt_rand(0,100)>50){
            this.start=[w_border[1]+w_border[0]-this.start[0],0];
            this.angle=Math.PI-this.angle;
        }
        if(this.angle>Math.PI/2){
            this.conf.dir=-1;
        }

         this.scale.set(this.conf.dir*this.scale_int/100,this.scale_int/100);

    }
    objCollisionThrow.prototype = Object.create(PIXI.Container.prototype);
    objCollisionThrow.prototype= $.extend(objCollisionThrow.prototype,{
        update:function(delta){

            this.myObj.myUpdate(delta);

            var div=this.step/this.step_max;
            var slow=[2,10];

            this.step+=delta/slow[0];

            var x=this.v0*this.step*Math.cos(this.angle);
            var y=this.v0*this.step*Math.sin(this.angle)-(this.g*this.step*this.step)/2;

            y=780-y;


            var angle=0,angle_pi=0;
            if(this.rotation_step){
                this.rotation_state=(this.rotation_state+this.rotation_step/slow[1]*delta)%360;
                angle=this.rotation_state;
                angle_pi=angle*Math.PI/180;
            }

            x+=this.start[0];


            if(this.scale_arr[0]!=this.scale_arr[1]){
                this.scale_int=this.scale_arr[0]+(this.scale_arr[1]-this.scale_arr[0])*div;
                this.scale.set(this.conf.dir*this.scale_int/100,this.scale_int/100);
            }

            this.x=x;
            this.y=y;
            this.rotation=angle_pi;


            if(this.collisionObj.isCut(this.myObj,{
                img_pos:[x,y],
                img_size:[this.width,this.height],
                angle_pi:angle_pi,
                scale_int:this.scale_int,
                dir:this.conf.dir
            })){

                return this.wasCut([x,y],[this.width,this.height],angle,this.scale_int);
            }








            if(this.step>=this.step_max*this.conf.step_part){
                var logObj={type:"end",cut_data:{
                    type:this.type,img_name:this.imgName,scale:this.scale_int,angle:angle,pos:[x,y]
                }};
                if(typeof this.conf.onEnd=="function"){
                    this.conf.onEnd.call(thisMain.gameObj,logObj);
                }
                thisMain.gameObj.addLog(logObj);



//                _eventLog[animIndex].push({event:"moveEnd",eventType:this.collisionObj.eventType,imgPos:[x,y]});
//                th.trigger("moveEnd",{eventType:this.collisionObj.eventType,imgPos:[x,y]});

                return 0;

            }
            return 1;
        },
        wasCut:function(pos,img_size,angle,scale){
            var logObj={type:"cut",cut_data:{
                type:this.type,img_name:this.imgName,scale:scale,angle:angle,pos:pos,
                dir:this.conf.dir,bossHits:-1
            }},isContinue=0;
            if(this.type=="boss"){
                logObj.bossHits=this.collisionObj.takeCutsNumber();
                if(this.collisionObj.takeCutsNumber()>=this.conf.boss_die_count){
                    thisMain.gameObj.addLog(logObj);
                } else {
                  isContinue=1;
                }
            }
            else{
                thisMain.gameObj.addLog(logObj);
            }
            if(typeof this.conf.onCut=="function"){
                this.conf.onCut.call(thisMain.gameObj,logObj);
            }
            return isContinue;
        },
        takeStartX:function(){
            return this.start[0];
        },

        remove:function(){
            this.myObj.myRemove();
            this.destroy();
        }
    });



    objCollisionCustom=function(type,conf){
        conf=$.extend({
            onEnd:false,
            onCut:false,
            cut_from_step:0
        },conf);
        this.type=type;
        myPixiObj.drawCustom.call(this,conf);
        this.removeChild(this.myObj);
        this.myObj = new cutGameElement[conf.anim_type](conf);
        this.addChild(this.myObj);
        this.collisionObj=new collisionObj({eventType:this.type});
    };
    objCollisionCustom.prototype = Object.create(myPixiObj.drawCustom.prototype);
    objCollisionCustom.prototype.update=function(delta){
        var isRunning=myPixiObj.drawCustom.prototype.update.call(this,delta);
        var x=this.x;
        var y=this.y;
        if(this.step_all>=this.conf.cut_from_step && this.collisionObj.isCut(this.myObj,{
            img_pos:[x,y],
            img_size:[this.width,this.height],
            angle_pi:this.rotation,
            scale_int:this.scale_int,
            dir:this.conf.dir
        })){
            var logObj={type:"cut",cut_data:{
                type:this.type,img_name:this.imgName,scale:this.scale_int,
                angle:(this.rotation/Math.PI*180)%360,pos:[x,y],dir:this.conf.dir
            }};
            if(typeof this.conf.onCut=="function"){

                this.conf.onCut.call(thisMain.gameObj,logObj);
            }
            thisMain.gameObj.addLog(logObj);
            return 0;
        }
        if(!isRunning){
            var logObj={type:"end",cut_data:{
                type:this.type,img_name:this.imgName,scale:this.scale_int,angle:(this.rotation/Math.PI*180)%360,pos:[x,y],
                dir:this.conf.dir
            }};
            if(typeof this.conf.onEnd=="function"){
                this.conf.onEnd.call(thisMain.gameObj,logObj);
            }
            thisMain.gameObj.addLog(logObj);
        }

        return isRunning;
    };


    var loaderOptions = {
        crossOrigin: true
    };
    this.loaderMain = new PIXI.loaders.Loader();
    var girl_name=$.takeGirlImage(game_conf.girl_id);
    var spineLoaderOptions = { metadata: { spineAtlasSuffix: '.atlas?11' } };
    var i,name,obj;

    //imagesPreloader
    for(name in game_conf.imagesPreloader){
        this.loaderMain.add(name,game_conf.imagesPreloader[name],loaderOptions);
    }
    for(name in game_conf.spinePreloader){
        this.loaderMain.add(name,game_conf.spinePreloader[name]);
    }




    this.loaderMain.load(function(loader, resources){
        cutObj=new cutLine(lastPoint,_moduleEvents,{on_load:function(){
            thisMain.gameObj=new ninjaGame();
            thisMain.gameObj.spineResources=resources;
            if(typeof game_conf.onLoad=="function"){
                game_conf.onLoad();
            }
        },appJQ:appJQ});
    });
    _moduleEvents.one("moduleClear",function(){
        thisMain.remove();
        _mySound.stopSoundAll();
    });




}
cutGame.prototype={
    start:function(){
        this.gameObj.start();
    },
    takeHowlong:function(){
        return Math.round(this.gameObj.deltaSum*1000/60);
    },
    getLogs:function(){
        var arr=this.gameObj.gameLogArr;
        this.gameObj.gameLogArr=[];
        return arr;
    },
    remove:function(){
        if(this.wasRemoved!=0){
            return false;
        }
        this.wasRemoved=1;
        this.loaderMain.reset();
        if(typeof this.gameObj!="undefined" && typeof this.gameObj.app!="undefined" && typeof this.gameObj.app.destroy!="undefined"){
            this.gameObj.app.destroy();
        }
        return true;
    },

    addStatic:function(type,conf){
        this.gameObj.addStatic(type,conf);
    },
    addMovePath:function(type,conf){
        this.gameObj.addMovePath(type,conf);
    },
    addThrow:function(type,conf){
        this.gameObj.addThrow(type,conf);
    },
    addCollisionCustom:function(type,conf){
        return this.gameObj.addCollisionCustom(type,conf);
    },
    addViewObj:function(objName,arg_arr){
        return this.gameObj.addViewObj(objName,arg_arr);
    },
    stopCut:function(){
        this.gameObj.isCutStop=1;
    },
    addFrontObj:function(objName,arg_arr){
        return this.gameObj.addFrontObj(objName,arg_arr);
    },
    takeSpineResources:function(){
        return this.gameObj.spineResources;
    },
    testSpineWithMap:function(spine_path,png_path,spine_conf){
        if(typeof spine_conf=="undefined"){
            spine_conf={};
        }

        this.loaderMain.add("test_spine",spine_path).
        add("test_png",png_path);

        var thm=this;


        this.loaderMain.load(function(loader, resources){

            var pos1=[1280/4,780/2];
            var pos2=[1280*3/4,780/2];

            thm.addFrontObj(myPixiObj.drawCustom,[{pos_start:pos1,step_max:0,img:"test_png"}]);
            thm.addFrontObj(myPixiObj.drawCustom,[{
                pos_start:pos1,step_max:0,img:"test_spine",anim_type:"spine",
                spine_conf:$.extend( {
                    spineResource:resources,
                    anim_loop:false,
                    freeze_part:0
                },spine_conf)


            }]);



            thm.addFrontObj(myPixiObj.drawCustom,[{pos_start:[pos2[0],pos2[1]+100],step_max:0,img:"test_png"}]);
            thm.addFrontObj(myPixiObj.drawCustom,[{
                pos_start:pos2,step_max:0,img:"test_spine",anim_type:"spine",
                spine_conf:$.extend( {
                    spineResource:resources,
                    anim_loop:false,
                    freeze_part:0
                },spine_conf)
            }]);




        });
    }
};
